enum NoteReminderMode {
    update = 'update',
    create = 'create',
}

export default NoteReminderMode;
